import { SCOPES } from 'common/permissions';
import { ENTITY_TYPE } from 'common/constants';
import { MenuItemDef } from './dashboard/nav';
import {
  AssessmentOutlined,
  BadgeOutlined,
  BeachAccess,
  Brush,
  CasesOutlined,
  CompareArrows,
  Dashboard,
  FormatColorFill,
  FreeCancellation,
  GroupOutlined,
  Groups2Outlined,
  Home,
  ListAlt,
  Payments,
  RecentActorsOutlined,
  RequestPage,
  RequestPageOutlined,
  RequestQuoteOutlined,
  Schedule,
  Title,
  Today,
  ViewTimelineOutlined,
  WorkOffOutlined,
  AssignmentAdd,
  ReceiptLong,
  AccountBalanceWallet,
} from '@mui/icons-material';

export const navData: MenuItemDef[] = [
  {
    labelKey: 'mainNavigation.home',
    path: '/',
    icon: <Home />,
  },
  {
    labelKey: 'mainNavigation.clients',
    path: '/clients',
    icon: <GroupOutlined />,
    viewScopes: [SCOPES['clients.read']],
    editScopes: [SCOPES['clients.read']],
  },
  {
    labelKey: 'mainNavigation.providers',
    path: '/providers',
    icon: <RecentActorsOutlined />,
    viewScopes: [SCOPES['providers.read']],
    editScopes: [SCOPES['providers.read']],
  },
  {
    labelKey: 'mainNavigation.projects',
    path: '/projects',
    icon: <CasesOutlined />,
    viewScopes: [SCOPES['projects.read']],
    editScopes: [SCOPES['projects.read']],
  },
  {
    labelKey: 'mainNavigation.timesheet',
    path: '/timesheet',
    icon: <ViewTimelineOutlined />,
    viewScopes: [SCOPES['timesheet.read']],
    editScopes: [SCOPES['timesheet.read']],
  },
  {
    labelKey: 'mainNavigation.employees',
    path: '/employees',
    icon: <BadgeOutlined />,
    viewScopes: [SCOPES['employees.read']],
    editScopes: [SCOPES['employees.read']],
  },
  {
    labelKey: 'mainNavigation.myTeam',
    path: '/myteam',
    icon: <Groups2Outlined />,
    requiresSupervisor: true,
  },
  // Reports Menu with children
  {
    labelKey: 'mainNavigation.reports',
    path: '/reports',
    icon: <AssessmentOutlined />,
    viewScopes: [SCOPES['reports.read']],
    editScopes: [SCOPES['reports.read']],
    entityType: ENTITY_TYPE.ANY,
    children: [
      {
        labelKey: 'mainNavigation.timesheet',
        path: '/reports/timesheet',
        icon: <Schedule />,
        viewScopes: [SCOPES['reports.timesheet.read']],
        editScopes: [SCOPES['reports.timesheet.read']],
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
      {
        labelKey: 'mainNavigation.timesheet',
        path: '/reports/timesheet/client',
        icon: <Schedule />,
        viewScopes: [SCOPES['reports.timesheet.read']],
        editScopes: [SCOPES['reports.timesheet.read']],
        entityType: ENTITY_TYPE.CLIENT,
      },
      {
        labelKey: 'mainNavigation.billing',
        path: '/reports/billing',
        icon: <Payments />,
        viewScopes: [SCOPES['reports.billing.read']],
        editScopes: [SCOPES['reports.billing.read']],
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
      {
        labelKey: 'mainNavigation.billing',
        path: '/reports/billing/client',
        icon: <RequestPage />,
        viewScopes: [SCOPES['reports.billing.read']],
        editScopes: [SCOPES['reports.billing.read']],
        entityType: ENTITY_TYPE.CLIENT,
      },
      {
        labelKey: 'mainNavigation.utilization',
        path: '/reports/utilization',
        icon: <AssignmentAdd />,
        viewScopes: [SCOPES['reports.utilization.read']],
        editScopes: [SCOPES['reports.utilization.read']],
        entityType: ENTITY_TYPE.ANY,
      },
      {
        labelKey: 'mainNavigation.allocationVsTimesheet',
        path: '/reports/allocation-vs-timesheet',
        icon: <CompareArrows />,
        viewScopes: [SCOPES['reports.timesheet.read']],
        editScopes: [SCOPES['reports.timesheet.read']],
        entityType: ENTITY_TYPE.ANY,
      },
    ],
  },
  // Human Resources Menu with children
  {
    labelKey: 'mainNavigation.humanResources',
    path: '/humanresources',
    icon: <Groups2Outlined />,
    viewScopes: [SCOPES['pto.read'], SCOPES['nonworkingday.read']],
    editScopes: [SCOPES['pto.read'], SCOPES['nonworkingday.read']],
    entityType: ENTITY_TYPE.ANY,
    children: [
      {
        labelKey: 'mainNavigation.regime',
        path: '/regime',
        icon: <Today />,
        viewScopes: [SCOPES['pto.read'], SCOPES['pto.add'], SCOPES['pto.edit']],
        editScopes: [SCOPES['pto.read'], SCOPES['pto.add'], SCOPES['pto.edit']],
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
      {
        labelKey: 'mainNavigation.myPTO',
        path: '/timeOff',
        icon: <WorkOffOutlined />,
        viewScopes: [SCOPES['pto.read'], SCOPES['pto.add'], SCOPES['pto.edit']],
        editScopes: [SCOPES['pto.read'], SCOPES['pto.add'], SCOPES['pto.edit']],
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
      {
        labelKey: 'mainNavigation.manage.PTO',
        path: '/timeOffHR',
        icon: <FreeCancellation />,
        viewScopes: [SCOPES['timeoff.rrhh']],
        editScopes: [SCOPES['timeoff.rrhh']],
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
      {
        labelKey: 'mainNavigation.holidays',
        path: '/Calendar/Holidays',
        icon: <BeachAccess />,
        viewScopes: [
          SCOPES['nonworkingday.read'],
          SCOPES['nonworkingday.add'],
          SCOPES['nonworkingday.edit'],
        ],
        editScopes: [SCOPES['nonworkingday.add'], SCOPES['nonworkingday.edit']],
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
    ],
  },
  // Invoices Menu with children
  {
    labelKey: 'mainNavigation.invoiceOrBilling',
    path: '/invoices-menu',
    icon: <RequestPageOutlined />,
    viewScopes: [
      SCOPES['invoice.read'],
      SCOPES['invoice.supplier.read'],
      SCOPES['accountspayable.read'],
      SCOPES['accountspayable.client.read'],
    ],
    editScopes: [
      SCOPES['invoice.read'],
      SCOPES['invoice.supplier.read'],
      SCOPES['accountspayable.read'],
      SCOPES['accountspayable.client.read'],
    ],
    entityType: ENTITY_TYPE.ANY,
    children: [
      {
        labelKey: 'mainNavigation.invoice.myInvoices',
        path: '/myInvoices',
        icon: <RequestQuoteOutlined />,
        viewScopes: [SCOPES['invoice.read']],
        editScopes: [SCOPES['invoice.read']],
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
      {
        labelKey: 'mainNavigation.invoice.myInvoices',
        path: '/myInvoices',
        icon: <RequestQuoteOutlined />,
        viewScopes: [SCOPES['invoice.read']],
        editScopes: [SCOPES['invoice.read']],
        entityType: ENTITY_TYPE.PROVIDER,
      },

      {
        labelKey: 'mainNavigation.billing.accountsPayable',
        path: '/accountspayable',
        icon: <Payments />,
        viewScopes: [SCOPES['accountspayable.read'], SCOPES['accountspayable.edit']],
        editScopes: [SCOPES['accountspayable.read'], SCOPES['accountspayable.edit']],
        entityType: ENTITY_TYPE.CORPORATE_ENTITY,
      },
      {
        labelKey: 'mainNavigation.billing.invoicing',
        path: '/invoicing',
        icon: <RequestPage />,
        viewScopes: [SCOPES['accountspayable.read'], SCOPES['accountspayable.edit']],
        editScopes: [SCOPES['accountspayable.read'], SCOPES['accountspayable.edit']],
        entityType: ENTITY_TYPE.CORPORATE_ENTITY,
      },

      {
        labelKey: 'mainNavigation.billing.invoicing',
        path: '/invoicing',
        icon: <RequestPage />,
        viewScopes: [SCOPES['accountspayable.client.read']],
        editScopes: [SCOPES['accountspayable.client.read']],
        entityType: ENTITY_TYPE.CLIENT,
      },

      {
        labelKey: 'mainNavigation.billing.newInvoice',
        path: '/newinvoice',
        icon: <AssignmentAdd />,
        viewScopes: [SCOPES['invoice.supplier.read'], SCOPES['invoice.supplier.add']],
        editScopes: [SCOPES['invoice.supplier.read'], SCOPES['invoice.supplier.add']],
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
      {
        labelKey: 'mainNavigation.billing.upload',
        path: '/uploadinvoice',
        icon: <RequestQuoteOutlined />,
        viewScopes: [SCOPES['invoice.supplier.read'], SCOPES['invoice.supplier.add']],
        editScopes: [SCOPES['invoice.supplier.read'], SCOPES['invoice.supplier.add']],
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
    ],
  },

  // Finance Menu
  {
    labelKey: 'mainNavigation.finance',
    path: '/finance',
    icon: <AccountBalanceWallet />,
    viewScopes: [SCOPES['account.read']],
    editScopes: [SCOPES['account.edit']],
    entityType: ENTITY_TYPE.CORPORATE_ENTITY,
    children: [
      {
        labelKey: 'mainNavigation.finance.accounts',
        path: '/accounts',
        icon: <ReceiptLong />,
        viewScopes: [SCOPES['account.read']],
        editScopes: [SCOPES['account.edit']],
        entityType: ENTITY_TYPE.CORPORATE_ENTITY,
      },
    ],
  },

  // Showcase Menu with children
  {
    labelKey: 'Showcase',
    icon: <Brush />,
    children: [
      {
        labelKey: 'Components',
        path: '/showcase/components',
        icon: <Dashboard />,
      },
      {
        labelKey: 'Colors',
        path: '/showcase/colors',
        icon: <FormatColorFill />,
      },
      {
        labelKey: 'Typography',
        path: '/showcase/typography',
        icon: <Title />,
      },
      {
        labelKey: 'DataGrid',
        path: '/showcase/datagrid',
        icon: <ListAlt />,
      },
    ],
  },
];
